import { createFileRoute, Outlet, Navigate } from '@tanstack/react-router';
import { useAuth } from '@/lib/hooks';
import { ROUTES } from '@/config/routes';

export const Route = createFileRoute('/_auth/_admin')({
  component: AdminLayoutComponent,
});

function AdminLayoutComponent() {
  const { isAdmin } = useAuth();

  if (!isAdmin) {
    return <Navigate to={ROUTES.DEPOSITS} />;
  }

  return (
      <Outlet />
  );
}
